import { useEffect, useState } from 'react';
import { Api } from '../../componentes/Api';
import { Card, CardBody,Row,Col, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter  } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';

const modeloDatos = {
   almacenID: 0, 
    empresaID: "",
    descripcion: "",
    ubicacionID: 1,
    activo:true,
    creadoPor: "",
    modificadoPor: "",
    fechaCreado: new Date,
    fechaModificado: new Date
   
}

const Almacen = () => {
    const [tabla, setTabla] = useState(modeloDatos);
    const [Listado, SetListado] = useState([]);
    const [pendiente, setPendiente] = useState(true);
    const [verModal, setVerModal] = useState(false);
    const [verModalDisponible, setverModalDisponible] = useState(false);
    const [ListadoDisponible, SetListadoDisponible] = useState([]);
    const [Listado1, SetListado1] = useState([]);


    const handleChange = (e) => {
        let value = e.target.nodeName === "SELECT" ? (e.target.value == "true" ? true : false) : e.target.value;
        setTabla({
            ...tabla,
            [e.target.name]: value
        })
    }


    const obtenerDisponible = async (e) => {
        let response = await fetch(Api + "VentasMantenimiento/ListaDisponible");

        if (response.ok) {
            let data = await response.json()
            var d = data.filter(z => z.almacenID == e).map(x => x)
            SetListadoDisponible(d)
        }
    }
    const obtenerDatosArticulos = async () => {
        let response = await fetch(Api + "VentasMantenimiento/listaArticulos");

        if (response.ok) {
            let data = await response.json()
    
                SetListado1(data)

        }
    }

    const obtenerDatos = async () => {
        let response = await fetch(Api + "VentasMantenimiento/listaAlmacen");

        if (response.ok) {
            let data = await response.json()
            SetListado(data)
            setPendiente(false)
        }
    }

    useEffect(() => {
        obtenerDatos();
        obtenerDatosArticulos()
    },[])


    const guardarCambios = async () => {
        tabla.empresaId = "PR";

        let response;
        if (tabla.almacenID == 0) {
          
            response = await fetch(Api + "VentasMantenimiento/GuardarAlmacen", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })

        } else {
            response = await fetch(Api + "VentasMantenimiento/EditarAlmacen", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
        }

        if (response.ok) {
            await obtenerDatos();
            setTabla(modeloDatos)
            setVerModal(!verModal);
            Swal.fire(
                'Guardado!',
                '',
                'success'
            )
        } else {
            alert("error al guardar")
        }

    }

    const eliminarDatos = async (id) => {

        Swal.fire({
            title: 'Esta seguro?',
            text: "Desea eliminar el producto",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'No, volver'
        }).then((result) => {
            if (result.value) {

                const response = fetch(Api + "evaluaciondesempeno/EliminarPregunta/" + id, { method: "DELETE" })
                    .then(response => {
                        if (response.ok) {

                            obtenerDatos();

                            Swal.fire(
                                'Eliminado!',
                                'El producto fue eliminado.',
                                'success'
                            )
                        }
                    })
            }
        })
    }

    const abrirEditarModal = (data) => {
        setTabla(data);
        setVerModal(!verModal);
    }
    const VerDisponible = (data) => {
        obtenerDisponible(data.almacenID)
         setverModalDisponible(!verModalDisponible);
    }
    const cerrarModal = () => {
        setTabla(modeloDatos)
        setVerModal(false)
        setverModalDisponible(false)
    }
    const columns1 = [
        {
            name: 'ArticuloID',
            selector: row => row.articuloID,
            sortable: true,
        }, {
            name: 'Descripcion',
            selector: row => (Listado1.find(x => x.articuloID == row.articuloID).descripcion),
            sortable: true,
        },  {
            name: 'Cantidad',
            selector: row => row.cantidad,
            sortable: true,
        },{
            name: 'Cod. Auxiliar',
            selector: row => (Listado1.find(x => x.articuloID == row.articuloID).codigoAuxiliar),
            sortable: true,
        },
    ]

    const columns = [
        {
            name: 'ID',
            selector: row => row.almacenID,
            sortable: true,
        },
        {
            name: 'Descripcion',
            selector: row => row.descripcion,
            sortable: true,
        },
       
       
        //{
        //    name: 'Estado',
        //    selector: row => row.esActivo,
        //    sortable: true,
        //    cell: row => {
        //        let clase;
        //        clase = row.esActivo ? "badge badge-info p-2" : "badge badge-danger p-2"
        //        return (
        //            <span className={clase}>{row.esActivo ? "Activo" : "No Activo"}</span>
        //        )
        //    }
        //}
        ,
        {
            name: '',
            cell: row => (
                <>
                    <Button color="primary" size="sm" className="mr-2"
                     onClick={() => abrirEditarModal(row)}
                    >
                        <i className="fas fa-pen-alt"></i>
                    </Button>
                      <Button color="primary" size="sm" className="mr-2"
                     onClick={() => VerDisponible(row)}
                    >
                        <i className="fas fa-list-ol"></i>
                    </Button>

                </>
            ),
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                fontSize: '13px',
                fontWeight: 800,
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
            }
        }
    };

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };

    return (
        <>
            <Card>
                <CardHeader style={{ backgroundColor: '#4e73df', color: "white" }}>
                    Lista de Almacen
                </CardHeader>
                <CardBody>
                    <Button color="success" size="sm"
                    onClick={() => setVerModal(!verModal)}
                    >Nuevo Almacen</Button>
                    <hr></hr>
                    <DataTable
                        columns={columns}
                        data={Listado}
                      progressPending={pendiente}
                       pagination
                      paginationComponentOptions={paginationComponentOptions}
                        customStyles={customStyles}
                    />
                </CardBody>
            </Card>

            <Modal isOpen={verModal}>
                <ModalHeader className="modal-header1">
                    Mantenimiento de Almacen
                </ModalHeader>
                <ModalBody>
                    <Row>
                    <Col >
                    <FormGroup>
                    
                        <Label>Descripcion</Label>
                                <Input bsSize="sm" name="descripcion" onChange={handleChange} value={tabla.descripcion} />
                        </FormGroup></Col>
                  </Row>
                </ModalBody>
                <ModalFooter>
                    <Button size="sm" color="primary"
                      onClick={guardarCambios}
                    >Guardar</Button>
                    <Button size="sm" color="danger"
                      onClick={cerrarModal}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={verModalDisponible} className="modal-preguntas">
                <ModalHeader className="modal-header1">
                    <div class="box">
                        <div>   Lista de articulos diponible en el almacen </div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={cerrarModal}>X</a></div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <DataTable
                            columns={columns1}
                            data={ListadoDisponible}
                         
                            pagination
                            paginationComponentOptions={paginationComponentOptions}
                            customStyles={customStyles}
                        />
                    </Row>
                </ModalBody>
                <ModalFooter>
                          <Button size="sm" color="danger"
                        onClick={cerrarModal}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>


        </>
        )

}
export default Almacen;